import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDeleteAlarmTypeGroup(
  alarmTypeGroupId: number,
  onSuccess: () => void
) {
  const url = `/v2/orm/alarmtype_groups/${alarmTypeGroupId}`;

  const request = new Request(url, {
    method: 'DELETE',
  });

  return useAuthenticatedMutation(request, {
    onSuccessInvalidationKeys: [['alarm-type-groups']],
    onSuccess,
  });
}

export default useDeleteAlarmTypeGroup;
